import {
  ConfigSelectors,
  ELanguage,
  LanguageSelectors,
  ProgressSelectors,
  renderStringToReact,
  useTranslation,
} from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import HintPopup from '../../components/HintPopup/HintPopup';
import ProgressGraph from '../../components/progress/ProgressGraph';
import { IState } from '../../store/state';
import * as Selectors from '../selectors';

// narrow typing of progress data needed for exercise progress representation
type TExerciseProgressEntry = { result: number; timestamp: number };

export interface IExerciseProgressProps {
  language: ELanguage | undefined;
  progress?: TExerciseProgressEntry[];
}

export const ExerciseProgressFC: React.FC<IExerciseProgressProps> = ({ language, progress }) => {
  const { t } = useTranslation();

  const progressData = progress
    ? progress.map((result) => ({ score: result.result, time: result.timestamp }))
    : progress;

  const buttonLabel = t('Exercise.PostWorkout.ProgressHintDialogOKLabel');
  const hintPopupTitle = t('Exercise.PostWorkout.ProgressHintDialogTitle');
  const hintPopupContent = t('Exercise.PostWorkout.ProgressHintContentHtml');

  const contentReactElement = renderStringToReact(hintPopupContent);

  if (!language) {
    return null;
  }

  return (
    <>
      <h2>
        {t('Exercise.PostWorkout.Progress')}
        <HintPopup title={hintPopupTitle} iconSize={24} okButtonLabel={buttonLabel}>
          {contentReactElement}
        </HintPopup>
      </h2>
      <div className="exercise-progress">
        <ProgressGraph locale={language} noDataLabel={t('Exercise.PostWorkout.NoData')} progress={progressData} />
      </div>
    </>
  );
};

export const mapStateToProps = (state: IState) => {
  const language = LanguageSelectors.getLanguage(state);
  const workoutId = Selectors.getWorkoutId(state);
  const workoutIdsOfCategoryGroup = ConfigSelectors.getWorkoutIdsOfCategoryGroup(state, workoutId);
  const progressLoaded = ProgressSelectors.isFullProgressLoaded(state);
  const progress = progressLoaded
    ? ProgressSelectors.getMergedProgressForWorkouts(state, workoutIdsOfCategoryGroup)
    : undefined;
  return {
    language,
    progress,
  };
};

const ExerciseProgress = connect(mapStateToProps)(ExerciseProgressFC);
export default ExerciseProgress;
